/* Veyron - comportamento das secoes de conteudo. Vanilla JS. */
(function () {
  'use strict';

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------------- Slideshow ---------------- */
  class VeySlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.vey-slideshow__slide'));
      this.dots = Array.from(this.querySelectorAll('.vey-slideshow__dot'));
      this.pauseBtn = this.querySelector('.vey-slideshow__pause');
      if (this.slides.length < 2) return;

      this.index = 0;
      this.interval = (parseInt(this.dataset.speed, 10) || 6) * 1000;
      this.playing = this.dataset.autoplay === 'true' && !reduceMotion;

      this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));
      if (this.pauseBtn) this.pauseBtn.addEventListener('click', () => this.toggle());

      let x0 = null;
      this.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        x0 = null;
      }, { passive: true });

      if (this.playing) this.start();
    }
    disconnectedCallback() { clearInterval(this.timer); }

    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
      this.dots.forEach((d, idx) => d.setAttribute('aria-selected', String(idx === this.index)));
    }
    start() { clearInterval(this.timer); this.timer = setInterval(() => this.go(this.index + 1), this.interval); }
    restart() { if (this.playing) this.start(); }
    toggle() {
      this.playing = !this.playing;
      if (this.playing) this.start(); else clearInterval(this.timer);
      if (this.pauseBtn) this.pauseBtn.setAttribute('aria-pressed', String(!this.playing));
    }
  }
  customElements.define('vey-slideshow', VeySlideshow);

  /* ---------------- Timeline ---------------- */
  class VeyTimeline extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('.vey-timeline__tab'));
      this.panels = Array.from(this.querySelectorAll('.vey-timeline__panel'));
      this.media = Array.from(this.querySelectorAll('.vey-timeline__media-item'));
      this.tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => this.go(i));
        tab.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { e.preventDefault(); this.focusTab(i + 1); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.focusTab(i - 1); }
        });
      });
    }
    focusTab(i) {
      const n = this.tabs.length;
      const t = this.tabs[((i % n) + n) % n];
      if (t) { t.focus(); t.click(); }
    }
    go(i) {
      this.tabs.forEach((t, idx) => t.setAttribute('aria-selected', String(idx === i)));
      this.panels.forEach((p, idx) => p.classList.toggle('is-active', idx === i));
      this.media.forEach((m, idx) => m.classList.toggle('is-active', idx === i));
    }
  }
  customElements.define('vey-timeline', VeyTimeline);

  /* ---------------- Testimonials ---------------- */
  class VeyTestimonials extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.vey-testimonials__slide'));
      if (this.slides.length < 2) return;
      this.index = 0;
      const prev = this.querySelector('[data-testimonial-prev]');
      const next = this.querySelector('[data-testimonial-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));

      if (this.dataset.autoplay === 'true' && !reduceMotion) {
        const ms = (parseInt(this.dataset.speed, 10) || 7) * 1000;
        this.timer = setInterval(() => this.go(this.index + 1), ms);
      }
    }
    disconnectedCallback() { clearInterval(this.timer); }
    go(i) {
      const n = this.slides.length;
      this.index = ((i % n) + n) % n;
      this.slides.forEach((s, idx) => s.classList.toggle('is-active', idx === this.index));
    }
  }
  customElements.define('vey-testimonials', VeyTestimonials);

  /* ---------------- Marquee ---------------- */
  class VeyMarquee extends HTMLElement {
    connectedCallback() {
      const viewport = this.querySelector('.vey-marquee__viewport');
      const track = this.querySelector('.vey-marquee__track');
      if (!viewport || !track || reduceMotion) return;
      const clone = track.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      viewport.appendChild(clone);
    }
  }
  customElements.define('vey-marquee', VeyMarquee);

  /* ---------------- Reviews gallery ---------------- */
  class VeyReviewsGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.vey-reviews__track');
      if (!this.track) return;
      const prev = this.querySelector('[data-reviews-prev]');
      const next = this.querySelector('[data-reviews-next]');
      const step = () => this.track.clientWidth * 0.8;
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
    }
  }
  customElements.define('vey-reviews-gallery', VeyReviewsGallery);

  /* ---------------- FAQ ---------------- */
  class VeyFaq extends HTMLElement {
    connectedCallback() {
      if (this.dataset.exclusive !== 'true') return;
      this.items = Array.from(this.querySelectorAll('.vey-faq__item'));
      this.items.forEach((item) =>
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          this.items.forEach((other) => { if (other !== item) other.open = false; });
        })
      );
    }
  }
  customElements.define('vey-faq', VeyFaq);

  /* ---------------- Quick buy ---------------- */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-quick-buy]');
    if (!btn) return;
    e.preventDefault();
    const id = btn.dataset.variantId;
    if (!id) return;
    btn.setAttribute('aria-busy', 'true');
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      if (res.ok) {
        const drawer = document.querySelector('vey-cart-drawer');
        if (drawer) { await drawer.refresh(); drawer.open(); }
        else window.location.href = window.Shopify.routes.root + 'cart';
      }
    } finally { btn.removeAttribute('aria-busy'); }
  });
})();
